import { Skeleton } from '@nexelem/components';
import clsx from 'clsx';

type DetailsLoadingSkeletonProps = {
  amount?: number;
  className?: string;
};

export const DetailsLoadingSkeleton = ({ amount = 3, className }: DetailsLoadingSkeletonProps) => (
  <div className={clsx('relative flex max-h-full grow flex-col gap-7 overflow-y-auto', className)}>
    {Array.from({ length: amount }, (_, key) => (
      <div className="flex flex-col gap-2" key={key}>
        <Skeleton className="h-4 w-25" />
        <Skeleton className="h-10" />
      </div>
    ))}
  </div>
);
